import React, { useState } from 'react';
import queryString from 'query-string';

import { myAccountLinkMap, RETURN_INITIATE_SOURCE } from 'constants/amethystEnums';
import useMartyContext from 'hooks/useMartyContext';
import { Input } from 'components/common/Input';

import css from 'styles/components/account/orderHistoryFindOrders.scss';

export const OrderHistoryFindOrders = ({
  location: { search },
  showBatchReturn,
  onSearchOrderHistory,
  hasExpandedOrderHistorySearch,
  onCancelOrderHistorySearch,
  onReturnItems,
  returnablesAvailable,
  onSearchByOrderIdSubmit,
  searchFormRef
}) => {
  const {
    marketplace: {
      account: { crossOrderReturns }
    },
    testId
  } = useMartyContext();
  const queryParams = queryString.parse(search);
  const { search: searchTerm } = queryParams || {};

  const [searchValue, setSearchValue] = useState(searchTerm || '');

  // once you manually set a value to an input field it becomes "managed" so have to use state to manage the value
  const onChange = e => {
    setSearchValue(e.target.value);
  };

  const handleCancelSearch = e => {
    setSearchValue('');
    onCancelOrderHistorySearch(e);
  };

  return (
    <div className={css.findOrder}>
      <div className={css.searchGroup}>
        <form
          ref={searchFormRef}
          method="post"
          role="search"
          aria-label="Order History"
          id="order-search-form"
          onSubmit={hasExpandedOrderHistorySearch ? onSearchOrderHistory : onSearchByOrderIdSubmit}
        >
          <label className="zappos:body-m" htmlFor="searchOrderHistory">
            Search items in your order history
          </label>
          <div className={css.inputGroup}>
            <Input
              className="zappos:body-m"
              type="search"
              id="searchOrderHistory"
              placeholder={hasExpandedOrderHistorySearch ? 'Search by Order Number, Brand, or Name' : 'Search by Order Number'}
              onChange={onChange}
              value={searchValue}
              required
              data-test-id={testId('orderSearchBox')}
            />
            <span className={css.inputGroupButton}>
              <button type="submit" data-amethyst-account-link={myAccountLinkMap.SEARCH_ORDERS_CLICK} data-test-id={testId('orderSearchSubmit')}>
                Search Orders
              </button>
            </span>
          </div>
          {searchTerm && (
            <div className={css.searchPrompt}>
              <p>Searching for "{searchTerm}".</p>
              <button onClick={handleCancelSearch} type="reset">
                Clear Search
              </button>
            </div>
          )}
        </form>
      </div>
      <div className={css.buttonGroup}>
        {crossOrderReturns && showBatchReturn && (
          <button
            type="button"
            onClick={onReturnItems}
            disabled={!returnablesAvailable}
            className={css.return}
            data-amethyst-account-link={myAccountLinkMap.RETURN_ITEMS_CLICK}
            data-amethyst-return-behavior-survey={RETURN_INITIATE_SOURCE.ACCOUNT_PAGE_RETURN_ITEMS_BUTTON}
            data-test-id={testId('returnItemsButton')}
          >
            Return Items
          </button>
        )}
      </div>
    </div>
  );
};

export default OrderHistoryFindOrders;
